module.exports = __webpack_public_path__ + "img/logo.382caf65.jpg";